/* Stickers Perso - motion & en-tete (vanilla JS, aucune dependance)
   - apparitions au scroll ([data-sp-reveal], [data-sp-pop])
   - en-tete : etat au scroll, sous-menus, recherche, menu mobile
   - respecte prefers-reduced-motion
*/
(function () {
  'use strict';
  var d = document;
  var root = d.documentElement;
  window.__spMotion = true;
  root.classList.add('sp-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Apparitions au scroll ---------- */
  var io = null;
  function reveal(scope) {
    var els = (scope || d).querySelectorAll('[data-sp-reveal]:not(.is-in), [data-sp-pop]:not(.is-in)');
    if (!els.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- En-tete ---------- */
  function header(scope) {
    var h = (scope || d).querySelector('[data-sp-header]');
    if (!h || h.__spReady) return;
    h.__spReady = true;
    var wrap = h.parentNode;

    /* ombre + logo reduit au scroll */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        h.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* sous-menus (clic / clavier ; le survol est gere en CSS) */
    var toggles = h.querySelectorAll('[data-sp-dd-toggle]');
    function closeDd(except) {
      toggles.forEach(function (b) { if (b !== except) b.setAttribute('aria-expanded', 'false'); });
    }
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = btn.getAttribute('aria-expanded') === 'true';
        closeDd(btn);
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
      btn.parentNode.addEventListener('mouseleave', function () { btn.setAttribute('aria-expanded', 'false'); });
    });
    d.addEventListener('click', function (e) { if (!h.contains(e.target)) closeDd(); });

    /* recherche */
    var sBtn = h.querySelector('[data-sp-search-toggle]');
    var sPanel = h.querySelector('[data-sp-search]');
    function openSearch() {
      sPanel.hidden = false;
      requestAnimationFrame(function () { sPanel.classList.add('is-open'); });
      sBtn.setAttribute('aria-expanded', 'true');
      var input = sPanel.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 60);
    }
    function closeSearch(returnFocus) {
      if (!sPanel || sPanel.hidden) return;
      sPanel.classList.remove('is-open');
      sBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { sPanel.hidden = true; }, 220);
      if (returnFocus) sBtn.focus();
    }
    if (sBtn && sPanel) {
      sBtn.addEventListener('click', function () { if (sPanel.hidden) { openSearch(); } else { closeSearch(false); } });
    }

    /* menu mobile */
    var drawer = wrap.querySelector('[data-sp-drawer]');
    var openBtn = h.querySelector('[data-sp-drawer-open]');
    function openDrawer() {
      drawer.hidden = false;
      root.style.overflow = 'hidden';
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      openBtn.setAttribute('aria-expanded', 'true');
      var c = drawer.querySelector('[data-sp-drawer-close-btn]');
      if (c) setTimeout(function () { c.focus(); }, 60);
    }
    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      root.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { drawer.hidden = true; }, 360);
      openBtn.focus();
    }
    if (drawer && openBtn) {
      openBtn.addEventListener('click', openDrawer);
      drawer.querySelectorAll('[data-sp-drawer-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
      /* garde le focus clavier dans le menu ouvert */
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var list = Array.prototype.filter.call(drawer.querySelectorAll('a[href], button, summary'), function (el) { return el.offsetParent !== null; });
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeDd();
      closeSearch(true);
      closeDrawer();
    });
  }

  function init(scope) {
    reveal(scope);
    header(scope);
  }
  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  /* editeur de theme : re-initialise une section rechargee */
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
